import React, { createContext, useState, useCallback, useMemo } from 'react';

export const MenuSettingsContext = createContext();

export const useMenuSettings = () => {
    const context = React.useContext(MenuSettingsContext);
    if (context === undefined) {
        throw new Error('useMenuSettings must be used within a MenuSettingsProvider');
    }
    return context;
};

export const MenuSettingsProvider = ({ children }) => {
    const [menuUpdate, setMenuUpdate] = useState(false);

    const triggerMenuUpdate = useCallback(() => {
        setMenuUpdate((prev) => !prev);
    }, []);

    // useMemo prevents a new object reference on every render,
    // which would cause all context consumers to re-render unnecessarily.
    const contextValue = useMemo(
        () => ({ triggerMenuUpdate, menuUpdate }),
        [triggerMenuUpdate, menuUpdate]
    );

    return (
        <MenuSettingsContext.Provider value={contextValue}>
            {children}
        </MenuSettingsContext.Provider>
    );
};